import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type BaseAppState, type EntityRef, Status } from "@client/types";
import { type Dispatch } from "redux";
import { initAction } from "../actions";
import api from "./api";
import { localStateSelector } from "./selectors";
import { type MemberVouchers } from "./types";

export enum Actions {
  InitBegin = "MEMBER_VOUCHERS_INIT_BEGIN",
  InitFailure = "MEMBER_VOUCHERS_INIT_FAILURE",
  InitSuccess = "MEMBER_VOUCHERS_INIT_SUCCESS",

  SetShowingItemId = "MEMBER_VOUCHERS_SET_SHOWING_ITEM_ID"
}

export type InitBeginActionData = EntityRef;
export interface InitSuccessActionData {
  vouchers: MemberVouchers.Voucher[];
}
export const _init = initAction<
  BaseAppState,
  InitBeginActionData,
  MemberVouchers.Api.InitResponse,
  InitSuccessActionData
>({
  types: {
    begin: Actions.InitBegin,
    failure: Actions.InitFailure,
    success: Actions.InitSuccess
  },
  action: (state: BaseAppState, dispatch: any, args: InitBeginActionData) => {
    const apiInfo = makeModuleApiInfoSelector()(state, args);
    return api.init(apiInfo, {});
  }
});

export type InitArgs = EntityRef & {};
export const init = (args: InitArgs) => (dispatch: Dispatch<any>, getState: () => BaseAppState) => {
  const state = getState();
  const localState = localStateSelector(state, args);
  if (localState.status === Status.None) {
    dispatch(_init(args));
  }
};

export type SetShowingDetailIdActionData = EntityRef & {
  itemId: string | null;
};
export const setShowingDetailId = (args: SetShowingDetailIdActionData) => ({
  type: Actions.SetShowingItemId,
  data: <SetShowingDetailIdActionData>args
});
